import { HandleScreenBarService } from './services/handle-screen-bar.service';

import { HeaderService } from './services/header.service';
import { ScreenTitleService } from './services/screen-title.service';
import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Imported Layout Service
import { LayoutService } from '../shared/services/layout.service';
// Imported Icons Module
import { IconsModule } from '../shared/icons/icons.module';
// Imported DropDownMenu Directrive
import { DropdownMenuDirective } from './directives/dropdown-menu.directive';

// Imported Step Wizard
import { ArchwizardModule } from 'angular-archwizard';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { TabsModule } from 'ngx-bootstrap/tabs';
// Global Used Services Imported
import { GlobalService } from '../shared/services/global.service';
import { ConfigService } from '../shared/services/config.service';
import { RestService } from '../shared/services/rest.service';
import { SweetAlertService } from 'angular-sweetalert-service';
import { NotificationsService } from 'angular4-simple-notifications';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

// Breadcrumb Modules Imported
import {BreadcrumbModule} from 'angular-crumbs';

// NGX Pagination Module imported
import {NgxPaginationModule} from 'ngx-pagination';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { OrderModule } from 'ngx-order-pipe';

//
import { ModalModule } from 'ngx-bootstrap/modal';
import { AccordionModule } from 'ngx-bootstrap/accordion';

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { LoadingSpinnerComponent } from './component/loading-spinner/loading-spinner.component';
import { TooltipModule } from 'ngx-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ToastrModule } from 'ngx-toastr';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import {CarouselModule} from 'primeng/carousel';
import {ButtonModule} from 'primeng/button';
import {ToastModule} from 'primeng/toast';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
@NgModule({
  declarations:
  [DropdownMenuDirective,
  LoadingSpinnerComponent,
],
  imports: [
    CommonModule,
    HttpClientModule,
    IconsModule,
    FormsModule,
    ReactiveFormsModule,
    ArchwizardModule,
    NgbModule,
    BreadcrumbModule,
    NgxPaginationModule,
    Ng2SearchPipeModule,
    OrderModule,
    ModalModule.forRoot(),
    AccordionModule.forRoot(),
    SweetAlert2Module.forRoot(),
    TooltipModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ToastrModule.forRoot(),
    PerfectScrollbarModule,
    CarouselModule,
    ButtonModule,
    ToastModule,
    TabsModule.forRoot()
  ],
  exports: [
    IconsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownMenuDirective,
    ArchwizardModule,
    NgbModule,
    BreadcrumbModule,
    NgxPaginationModule,
    Ng2SearchPipeModule,
    OrderModule,
    ModalModule,
    AccordionModule,
    SweetAlert2Module,
    LoadingSpinnerComponent,
    TooltipModule,
    BsDatepickerModule,
    ToastrModule,
    PerfectScrollbarModule,
    CarouselModule,
    ButtonModule,
    ToastModule,
    TabsModule
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return{
      ngModule: SharedModule,
      providers: [
        LayoutService,
        ScreenTitleService,
        GlobalService,
        HeaderService,
        ConfigService,
        RestService,
        SweetAlertService,
        NotificationsService,
        Ng4LoadingSpinnerService,
        HandleScreenBarService,
        {
          provide: PERFECT_SCROLLBAR_CONFIG,
          useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }
      ],
    };
  }
}
